import Axios, { AxiosError, AxiosResponse } from 'axios';
import { HTTP_CODE } from './constants';
import { userServices } from 'services';
import { notification } from 'antd';
import { t } from 'i18n';
import { debounce } from 'lodash';
import { NOTI_DEBOUNCE_TIME } from 'constants/common';
import taskContants from 'constants/task';
import '@terra-js/web-bridge';
import TerraKit from '@terra-js/terra-kit';

const { API_PREVENT_NOTI_ERR, CODE_PREVENT_NOTI_ERR } = taskContants;

export const getData = (res: AxiosResponse<any>) => res.data;

const { CODE_401, CODE_403, CODE_CONFIRM_EXCEPTION, CODE_400 } = HTTP_CODE;

export const handleResponseError = debounce(async (error: AxiosError) => {
  const status = error && error.response && error.response.status;
  switch (status) {
    case CODE_401:
      if (TerraKit.isAvailable()) {
        const result = await TerraKit.auth().refreshAccessToken();
        error.config.headers['Authorization'] = 'Bearer ' + result.getValue();
        return Axios.request(error.config);
      }
      userServices.logout();
      break;
    case CODE_403:
      userServices.denyAccess();
      notification.error({
        message: t('Error'),
        description: t('UsernameOrPasswordWrong'),
      });
      break;
    case CODE_CONFIRM_EXCEPTION:
    default:
      if (
        status === CODE_400 &&
        error.response?.config.url &&
        API_PREVENT_NOTI_ERR.includes(error.response.config.url) &&
        CODE_PREVENT_NOTI_ERR.includes(error.response?.data.code)
      ) {
        return;
      }

      // Handle error message from API response
      let message = null;
      if (error.response && error.response.data) {
        const { data } = error.response;
        message = data.message;
      }
      notification.error({
        message: t('Error'),
        description: message || t('SomethingWentWrong'),
      });
      break;
  }
}, NOTI_DEBOUNCE_TIME);
